/**
 * Sidebar modules
 */
export * from './sidebar';



//////////////////
// WEBPACK FOOTER
// ./node_modules/@syncfusion/ej2-navigations/src/sidebar/index.js
// module id = 1902
// module chunks = 0